import { baseApi } from "@Services/api";

export const inboxApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        sendInstagramMessage: builder.mutation<any, { id: string; ig_id: string; text: string }>({
            query: (body) => ({
                url: "/v0/api/instagram/send_message",
                method: "POST",
                body,
            }),
        }),
        getFirebaseToken: builder.query<{ data: { token: string; page_ids: [] } }, void>({
            query: () => ({
                url: "/v0/api/auth/firebase_token",
                method: "GET",
            }),
        }),
    }),
});

export const { useSendInstagramMessageMutation, useLazyGetFirebaseTokenQuery } = inboxApi;
